import QuizDivider from './QuizDivider';

export default QuizDivider;
